export const counterPatternFactory = ({current, total}) => `${current}/${total}`
export const blockScrollPage = () => (document.body.style.overflow = 'hidden')
export const enableScrollPage = () => (document.body.style.overflow = 'auto')
// Video utils 👇🏽
export const isExternalVideo = url => url.includes('yams') === false
export const getAutoPlayValue = ({autoPlay, avoidOnViewportAutoPlay, isVideoPlaying}) => {
  if (isVideoPlaying) return true

  if (avoidOnViewportAutoPlay) return autoPlay

  return autoPlay ? 'ON_VIEWPORT' : false
}
